import * as React from 'react';
import { Color } from '../../styles/colors';
import Logos from './components/logos';
import LegalLinks from './components/legal-links';
import AccessibilityLink from './components/accessibility-link';
import { LEGAL_LINKS } from './data/legal-links';
import { LOGOS } from './data/logos';

const FooterSecure = () => (
  <section
    className="d-print-none py-sm-24 py-lg-60"
    style={{
      color: Color.tertiary100,
    }}
  >
    <div className="container">
      <div className="row">
        <LegalLinks className="col-sm-12 col-lg-6" items={LEGAL_LINKS} />
        <Logos className="col-sm-12 col-lg-6 justify-content-lg-end mt-sm-24 mt-lg-0" items={LOGOS} />
        <div className="col-sm-12">
          <AccessibilityLink />
        </div>
      </div>
    </div>
  </section>
);

export default FooterSecure;
